<template>
  <div id="root">
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="21">
        <div class="grid-content bg-purple">
          <h1>
            {{ title }}
          </h1>
        </div>
      </el-col>
      <el-col :span="9">
        <el-button
          type="primary"
          style="position: absolute; top: 19px;"
          @click="generateQR()"
          v-if="isOneOfTheseRoles(['td', 'missionary'])"
        >
          <span v-if="!downloading">
            <i class="fas fa-qrcode" /> Get QR Code
          </span>
          <span v-if="downloading">Downloading QR Code</span>
        </el-button>
      </el-col>
      <el-col :span="14">
        <el-button
          type="primary"
          style="position: absolute; top: 19px;"
          @click.native="handleSave"
          v-if="isOneOfTheseRoles(['td', 'missionary'])"
        >
          <i class="fas fa-file-export" /> Export QR Code Contacts
        </el-button>
      </el-col>
      <el-col :span="12">
        <el-button
          type="primary"
          style="position: absolute; top: 19px;"
          @click.native="modals.downloadCsv = true"
          v-if="isOneOfTheseRoles(['td', 'missionary'])"
        >
          <i class="fas fa-file-export" /> Export Custom List
        </el-button>
      </el-col>
      <el-col :span="2">
        <div class="grid-content" v-if="!error" />
        <p-button
          type="default"
          size="lg"
          icon
          round
          @click="handleNewPerson()"
        >
          <i class="nc-icon nc-simple-add" />
        </p-button>
      </el-col>
    </el-row>
    <h5 v-if="loading" style="text-align:center">
      Loading...
    </h5>
    <r-paginated-search-table
      v-if="!error"
      :data="people"
      :parent-namespace="namespace"
      @updateTable="getPeople"
    >
      <template v-slot:search>
        <fg-input
          class="input-sm"
          @keyup.enter="updateSearch"
          placeholder="Search"
          v-model="searchQuery"
        />
      </template>
      <el-table-column
        prop="name"
        label="Name"
        width="220"
      />
      <el-table-column
        prop="gender"
        label="Gender"
        width="100"
      />
      <el-table-column
        prop="school_year"
        label="School Year"
      />
      <el-table-column
        prop="email"
        label="Primary Email"
      />
      <el-table-column
        prop="phone"
        label="Phone"
      />
      <el-table-column
        prop="primary_role"
        label="Role"
      />
      <el-table-column
        prop="primary_location"
        label="Campus"
        v-if="isOneOfTheseRoles(['regional', 'admin', 'superadmin'])"
      />
      <el-table-column
        label="Actions"
        width="200"
      >
        <template slot-scope="scope">
          <!-- <p-button
            type="default"
            round
            size="sm"
            icon
            @click="handleShow(props.$index, props.row)"
          >
            <i class="el-icon-view el-icon--right" /> Show
          </p-button> -->
          <p-button
            outline
            round
            @click="show(scope.$index)"
          >
            <i class="el-icon-view el-icon--left" /> View Profile
          </p-button>
          <p-button
            v-if="getUserIdFromIndex(scope.$index) && isOneOfTheseRoles(['superadmin'])"
            outline
            round
            @click="assumeUser(getUserIdFromIndex(scope.$index))"
          >
            Assume User
          </p-button>
        </template>
        <!-- <template
          slot-scope="scope"
          @click="show(index)"
        > -->
        <!-- <el-dropdown
              split-button
              type="primary"
              size="small"
              @command="handleDropdownCommand($event, scope.$index)"
              @click="handleDropdownCommand('show', scope.$index)"> -->
        <!-- <i class="el-icon-view el-icon--right" /> Show
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-edit" command="edit">
              Edit
            </el-dropdown-item>
          </el-dropdown-menu>
          </el-dropdown>
        </template> -->
      </el-table-column>
    </r-paginated-search-table>
    <h3 v-else>
      {{ error }}
    </h3>
    <download-csv-modal
      :show="modals.downloadCsv"
      @close="modals.downloadCsv = false"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import {
    mapState, mapActions, vuex, mapGetters
} from 'vuex';
import PaginatedSearchTable from '../../components/Shared/PaginatedSearchTable';
import { RepositoryFactory } from '../../repositories/repositoryFactory';
import apiService from '../../repositories/apiService';

import DownloadCsvModal from '../../components/People/DownloadCSVModal';

const PeopleRepository = RepositoryFactory.get('people');
const LocationsRepository = RepositoryFactory.get('locations');
const data = 'People';

export default {
    data() {
        return {
            title: 'People',
            namespace: 'People',
            searchQuery: '',
            loading: false,
            downloading: false,
            modals: {
                downloadCsv: false
            }
        };
    },
    components: {
        [PaginatedSearchTable.name]: PaginatedSearchTable,
        DownloadCsvModal
    },
    computed: {
        ...mapState({
            people: (state) => state.People.people,
            error: (state) => state.People.error,
        }),
        // ...mapGetters({
        //     abbreviatedMeditationContent: 'people/abbreviatedMeditationContent'
        // })
    },
    methods: {
        getIdFromIndex(index) {
            return this.people[index].id;
        },
        getUserIdFromIndex(index) {
            return this.people[index].user_id;
        },
        updateSearch() {
            this.$store.dispatch('People/Pagination/searchUpdated', {
                search: this.searchQuery
            }).then(() => {
                this.getPeople();
            });
        },
        getPeople() {
            this.loading = true;
            this.$store.dispatch(`${this.namespace}/getPeople`).then(() => { this.loading = false; }).catch((error) => {
                this.loading = false;
            });
        },
        show(index) {
            this.$router.push({ name: 'PersonShow', params: { id: this.getIdFromIndex(index) } });
        },
        handleNewPerson() {
            this.$router.push({ name: 'PersonNew' });
        },
        generateQR() {
            this.downloading = true;
            LocationsRepository.generateQrForRegistration()
                .then((response) => {
                    // Download file from browser
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);
                    const anchor = document.createElement('a');
                    anchor.download = 'qr.pdf';
                    anchor.href = url;
                    anchor.click();
                    this.downloading = false;
                })
                .catch((error) => {
                    this.$message(error.response.data.message);
                    this.downloading = false;
                });
        },
        handleSave() {
            this.saving = true;
            PeopleRepository.csvExport('qr-code-contacts', 'all-students')
                // Get csv back from backend
                .then((response) => {
                    // Download file from browser
                    const blob = new Blob([response.data], { type: 'application/csv' });
                    const url = window.URL.createObjectURL(blob);
                    const anchor = document.createElement('a');
                    anchor.download = 'qr_contacts.csv';
                    anchor.href = url;
                    anchor.click();
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                    this.$message(error.response.data.message);
                });
        },
        assumeUser(assumedId) {
            if (this.isOneOfTheseRoles(['superadmin'])) {
                apiService
                    .get(`/assume/${assumedId}/`)
                    .then((response) => {
                        this.$router.go('/main');
                    }).catch((error) => {
                        this.$store.commit('setError', error);
                        this.loading = false;
                        this.error = error.response.data.message;
                    });
            }
        }
    },
    created() {
        this.$store.commit(`${this.namespace}/Pagination/setItemsPerPage`, 10);
        this.$store.commit(`${this.namespace}/Pagination/setCurrentPage`, 1);
        this.getPeople();
        this.$store.commit('People/setError', '');
    },
    beforeDestroy() {
        // todo destroy the state.
    }
};
</script>
